import faqEn from '@/data/faq.json'
import faqDe from '@/data/faq.de.json'
import { Locale, prefixLocale } from '@/i18n'

export interface NavItem {
  title: string
  href: string
  items?: NavItem[]
  badge?: string
  external?: boolean
}

export interface NavSection {
  title: string
  items: NavItem[]
}

const FAQ_BY_LOCALE: Record<Locale, any> = {
  en: faqEn,
  de: faqDe,
}

export function getFaqData(locale: Locale) {
  return FAQ_BY_LOCALE[locale] || FAQ_BY_LOCALE.en
}

export function getNavigation(locale: Locale): NavSection[] {
  const data = getFaqData(locale)
  return data.sections.map((section: any) => ({
    title: section.title,
    items: section.questions.map((question: any) => ({
      title: question.navTitle || question.title,
      href: prefixLocale(`/faq/${section.id}/${question.slug}`, locale),
    })),
  }))
}

export interface FlatPage {
  title: string
  href: string
  section: string
}

export function flattenNavigation(locale: Locale): FlatPage[] {
  const pages: FlatPage[] = []
  const nav = getNavigation(locale)
  for (const section of nav) {
    for (const item of section.items) {
      pages.push({ title: item.title, href: item.href, section: section.title })
      if (item.items) {
        for (const child of item.items) {
          pages.push({ title: child.title, href: child.href, section: section.title })
        }
      }
    }
  }
  return pages
}

export function getAdjacentPages(currentPath: string, locale: Locale) {
  const flat = flattenNavigation(locale)
  const idx = flat.findIndex((p) => p.href === currentPath)
  return {
    prev: idx > 0 ? flat[idx - 1] : null,
    next: idx < flat.length - 1 ? flat[idx + 1] : null,
  }
}
